import React from 'react'
import './header.css'
import CTA from './CTA'
import profile from '../../assets/imgs/Profile.png'
import HeaderSocial from './headerSocials'
const header = () => {
  return (
    <header>
      <section id="home" class="hero-section">
  <div class="hero-container">
        <div class="hero-text">
              <h4>Web Developer</h4>
              <h2>Jordan Chung</h2>
              <a href="#projects" class="btn">My Work</a>
        </div>
   </div>
</section>
    </header>
  )
}

export default header